export default __webpack_public_path__ + "static/23-9679d441a1b33e9121c7b83099aef9dc.jpg";